module.exports = __webpack_public_path__ + "static/img/bg-image.f276f15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingyun/bg-image.jpg
// module id = +1px
// module chunks = 1